<template>
  <el-tag
    :type="getTagType(status)"
    :effect="effect"
    :size="size"
    class="company-status-tag"
  >
    {{ COMPANY_STATUS_MAP[status] }}
  </el-tag>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import type { PropType } from 'vue';
import type { CompanyStatus } from '@/types/company';
import { COMPANY_STATUS_MAP } from '@/types/company';

const props = defineProps({
  status: {
    type: String as PropType<CompanyStatus>,
    required: true
  },
  effect: {
    type: String as PropType<'light' | 'dark' | 'plain'>,
    default: 'light'
  },
  size: {
    type: String as PropType<'large' | 'default' | 'small'>,
    default: 'default'
  }
});

const getTagType = (status: CompanyStatus) => {
  switch (status) {
    case 'planned':
      return 'info';
    case 'submitted':
      return 'primary';
    case 'interviewing':
      return 'warning';
    case 'offered':
      return 'success';
    case 'accepted':
      return 'success';
    case 'rejected':
      return 'danger';
    default:
      return 'info';
  }
};
</script>

<style scoped>
.company-status-tag {
  border-radius: 12px;
  font-weight: 500;
  padding: 0 10px;
}
</style> 